import { render } from "./AdminLayout.vue?vue&type=template&id=1c24891c&scoped=true&ts=true"
import script from "./AdminLayout.vue?vue&type=script&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&lang=ts"

import "./AdminLayout.vue?vue&type=style&index=0&id=1c24891c&scoped=true&lang=css"

import exportComponent from "/var/www/trovare/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c24891c"]])

export default __exports__